/**
 * @desc Export table layout configuration.
 * @example
 * import { dimensions } from 'config/dimensions/pharmacy-auth-criteria-grid';
 */
export const dimensions = {
    name: 170,
    address: 200,
    phone: 150,
};
